import React, { useContext } from 'react';
import ButtonGreen from './ButtonGreen';
import GradientBorder from '../../ui/GradientBorder';
import greenpillmetamask from '../../assets/greenpill/greenpillmetamask.png';
import greenpillphantom from '../../assets/greenpill/greenpillphantom.png';
import { getMetaMaskProvider } from '../../blockchainInteraction/finaliseGrading';
import { toast } from 'sonner';
import { AuthContext } from '../../contexts/AuthContext';
import { updateWallet } from '../../apis/geenpills/updateWallet';
import { useWallet } from '@solana/wallet-adapter-react';
import ButtonNew from '../../ui/ButtonNew';

// const metaConnection = async (linkedWallet) => {
//     const metaMaskProvider = getMetaMaskProvider();
//     if (!metaMaskProvider) {
//         const installUrl = 'https://metamask.io/download.html';
//         toast.info('Opening MetaMask installation page in a new tab...');
//         window.open(installUrl, '_blank'); // Open the URL in a new tab
//         // toast.error('MetaMask is not installed or unavailable');
//         return;
//     }
//     const accounts = await metaMaskProvider.request({
//         method: 'eth_requestAccounts',
//     });
//     console.log(accounts);
//     if (!accounts || accounts.length === 0) {
//         toast.error('Failed to connect wallet');
//         return;
//     }

//     if (accounts[0]?.toLowerCase() === linkedWallet?.toLowerCase()) {
//         toast?.error('This wallet is already connected to your profile.You can mint now');
//         return;
//     }

//     console.log('update the wallet here and then navigate the user back to minting after updating the state');
// };

const metaConnection = async (linkedWallet) => {
    const metaMaskProvider = getMetaMaskProvider();

    if (!metaMaskProvider) {
        const installUrl = 'https://metamask.io/download.html';
        toast.info('Opening MetaMask installation page in a new tab...');
        window.open(installUrl, '_blank');
        return;
    }

    try {
        // Always prompt MetaMask popup
        const accounts = await metaMaskProvider.request({
            method: 'wallet_requestPermissions',
            params: [{ eth_accounts: {} }],
        });

        // Now explicitly request selected accounts again
        const selectedAccounts = await metaMaskProvider.request({
            method: 'eth_requestAccounts',
        });

        if (!selectedAccounts || selectedAccounts.length === 0) {
            toast.error('No wallet selected. Connection cancelled.');
            return;
        }

        const newWallet = selectedAccounts[0]?.toLowerCase();
        const existingWallet = linkedWallet?.toLowerCase();

        if (newWallet === existingWallet) {
            toast.error(
                'This wallet is already connected. To switch wallets, please disconnect from MetaMask first and choose the account to which you want to connect.'
            );
            return;
        }

        return newWallet;
    } catch (error) {
        console.error('MetaMask connection error:', error);
        toast.error('Failed to connect MetaMask wallet.');
    }
};
const phantomConnection = async (linkedWallet, wallet) => {
    try {
        const phantom = wallet.wallets.find((w) => w.adapter.name === 'Phantom');
        if (!phantom || !phantom.adapter) {
            toast.error('Phantom wallet not found');
            return;
        }

        if (phantom.adapter?.name !== 'Phantom') {
            await wallet.select(phantom.adapter.name);
        }

        if (!phantom.adapter.connected) {
            await phantom.adapter.connect();
        }

        const publicKey = phantom.adapter.publicKey;
        if (!publicKey) {
            toast.error('Failed to get Phantom wallet address');
            return;
        }

        const newWallet = publicKey.toBase58()?.toLowerCase();
        const existingWallet = linkedWallet?.toLowerCase();

        if (newWallet === existingWallet) {
            toast.error(
                'This wallet is already connected. To switch wallets, please disconnect from Phantom first and choose the account to which you want to connect.'
            );
            return;
        }

        return publicKey.toBase58();
    } catch (error) {
        console.error('Phantom Wallet Error:', error);
        toast.error('Error connecting to Phantom wallet');
    }
};

const ChangeWallet = ({ close, handleChangeWalletAddress, type, linkedWallet, from }) => {
    const { dispatch } = useContext(AuthContext);
    const wallet = useWallet();

    console.log(type, from, linkedWallet, 'working on phantom');
    const changeHandler = async () => {
        if (type === 'phantom') {
            const newWallet = await phantomConnection(linkedWallet, wallet);
            if (newWallet && newWallet !== linkedWallet) {
                const response = await updateWallet(undefined, newWallet);
                if (response?.response?.data?.code === 400) {
                    toast?.error(response?.response?.data?.message);
                }

                if (response?.walletAddress) {
                    toast?.success('Wallet changed successfully');
                    dispatch({ type: 'changeWalletSolana', payload: newWallet });
                    // or 'phantom' depending on type
                }
            }
        }
        if (type === 'metamask') {
            const newWallet = await metaConnection(linkedWallet);
            if (newWallet && newWallet !== linkedWallet) {
                const response = await updateWallet(newWallet, undefined);
                if (response?.response?.data?.code === 400) {
                    toast?.error(response?.response?.data?.message);
                }

                if (response?.evmAddress) {
                    toast?.success('Wallet changed successfully');
                    dispatch({ type: 'changeWalletEVM', payload: newWallet });
                    // or 'phantom' depending on type
                }
            }
        }

        handleChangeWalletAddress('', '');
    };

    return (
        <div>
            <div className="flex items-center justify-between">
                <ButtonNew
                    onClick={() => {
                        handleChangeWalletAddress('', '');
                    }}
                    variant="closeNeutral"
                    size="xs"
                    shape="oval"
                    className=" !p-0"
                    fixedMinWidth
                    minWidthClass="min-w-[2.5rem]"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <circle cx="14.5713" cy="15.4287" r="14.5713" fill="none" />
                        <path
                            d="M17.6378 10.3794L16.4846 9.29346L9.96875 15.4287L16.4846 21.564L17.6378 20.4781L12.2753 15.4287L17.6378 10.3794Z"
                            fill="#B2B2B2"
                        />
                    </svg>
                </ButtonNew>

                <h1
                    className="text-2xl font-semibold text-tPrimary"
                    style={{
                        textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                    }}
                >
                    <>
                        Are you sure you want to
                        <br />
                        change the linked wallet?
                    </>
                </h1>
                <ButtonNew
                    onClick={() => {
                        close();
                    }}
                    variant="closeNeutral"
                    size="xs"
                    shape="oval"
                    className=" !p-0"
                    fixedMinWidth
                    minWidthClass="min-w-[2.5rem]"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <circle cx="15" cy="15" r="15" fill="none" />
                        <path d="M20.5918 10L10.5914 20.0004" stroke="#B2B2B2" strokeWidth="2" strokeLinecap="round" />
                        <path d="M20 20L9.99964 9.99964" stroke="#B2B2B2" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </ButtonNew>

            </div>
            <p className="text-tSecondary mt-3 mb-6 text-center ">
                Update your wallet address below or go back to use existing wallet
            </p>

            <div className="flex items-center justify-center">
                {/* <GradientBorder
                    radiusBorder={'.25rem'}
                    color2={'rgba(80, 108, 102, 0)'}
                    color1={'rgba(105, 159, 132, 1)'}
                    bg="bg-[#1E3D36]"
                    shadow="shadow-button-shadow"
                >
                    <button
                        onClick={changeHandler}
                        type="button"
                        className={` px-4 py-2 flex items-center gap-2   justify-between`}
                    >
                        <img
                            className="w-7 h-7 object-cover rounded-full"
                            src={type === 'metamask' ? greenpillmetamask : greenpillphantom}
                            alt="metamask"
                        />
                        <span className="text-white">Change Wallet</span>
                    </button>
                </GradientBorder> */}
                <GradientBorder
                    radiusBorder={'.25rem'}
                    color2={'#367567'}
                    color1={'#367567'}
                    bg={'bg-[#367567]'}
                    borderThickness="0px"
                    // shadow="shadow-button-shadow"
                    width={'w-[12rem]'}
                >
                    <button
                        onClick={changeHandler}
                        type="button"
                        className={` px-4 py-2 flex items-center gap-2 w-[12rem]  justify-center text-white`}
                    >
                        <span className=" gap-2">Change Wallet</span>
                    </button>
                </GradientBorder>
            </div>
        </div>
    );
};

export default ChangeWallet;
